var React = require('react');

function IconCircleX (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Paths"},[React.createElement("circle",{"id":"Ellipse 36","cx":"12","cy":"12","r":"10.8","stroke":"#142B6F","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"id":"Vector 38","d":"M7.79999 16.2L16.2 7.80005","stroke":"#142B6F","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round","key":1}),React.createElement("path",{"id":"Vector 39","d":"M16.2 16.2L7.79999 7.79995","stroke":"#142B6F","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round","key":2})]));
}

IconCircleX.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = IconCircleX;

IconCircleX.default = IconCircleX;
